import React from 'react';
import styled from 'styled-components';

const PaginationStyles = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;
  text-align: center;
  padding-right: 2rem;
  padding-left: 2rem;

  & > * {
    color: white;
    padding: 1rem;
    text-decoration: none;

    &[aria-current],
    &.current {
      border-bottom: 1px solid white;
    }

    &[disabled] {
      pointer-events: none;
      color: var(--grey);
    }
  }

  @media (max-width: 800px) {
    font-size: 1.4rem;
    flex-wrap: wrap;
    width: 100%;

    .word {
      display: none;
    }
  }
`;

export default function Pagination({
                                     pageSize,
                                     totalCount,
                                     currentPage,
                                     changePage,
                                   }) {
  const totalPages = Math.ceil(totalCount / pageSize);

  const handleOnChange = (index) => {
    if (typeof changePage === 'function') changePage(index)
  }

  return (
    <PaginationStyles>
      {Array.from({length: totalPages}).map((_, i) => (
        <button
          key={i}
          className={currentPage === i ? 'current' : ''}
          onClick={() => {
            handleOnChange(i)
          }}
        >
          {i + 1}
        </button>
      ))}
    </PaginationStyles>
  );
}
